import TopBar from '@components/TopBar/TopBar';
import { GroupProps } from '@shared/components/Group/Group';
// Assets
import { ReactComponent as Raport } from '@shared/assets/icons/raport.svg';
// Styles
import 'react-toastify/dist/ReactToastify.css';
import RoutePaths from '@routePaths';
import Footer from '@components/Footer/Footer';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { isE2EWithoutSso } from '@e2e/e2eAuth';
import { ToastContainer } from 'react-toastify';

export const dashboardSideMenu: GroupProps[] = [
  {
    title: 'Dashboards',
    icon: <Raport />,
    links: [
      {
        text: 'Dashboards',
        link:  RoutePaths.Home,
      },
      {
        text: 'Callback requests',
        link: RoutePaths.CallbackRequests,
      },
    ],
  },
];

const Layout = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const { instance } = useMsal();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Handle the redirect callback and extract app state
  useEffect(() => {
    const handleRedirect = async () => {
      if (isE2EWithoutSso) {
        return;
      }
      const response = await instance.handleRedirectPromise();
      if (response) {
        const appState = response.state ? JSON.parse(response.state) : undefined;
        const redirectTo = appState?.redirectTo || '/';
        navigate(redirectTo);
      }
    };
    handleRedirect();
  }, [instance, navigate]);

  return (
    <>
      <TopBar />
      {children}
      {!pathname.startsWith('/users/') && <Footer />}
      <ToastContainer />
    </>
  );
};

export default Layout;
